/**
 * Nomes das 32 casas em cada tema (tabuleiro do Business Tour). O motor não depende
 * disto; o cliente usa para a tela.
 *
 * Ordem: 0 Início · 1-7 lado 1 · 8 Ilha · 9-15 lado 2 · 16 Campeonato · 17-23 lado 3 ·
 * 24 Volta ao Mundo · 25-31 lado 4. Em cada lado: cidade, cidade, carta (imposto no
 * lado 4), cidade, resort, cidade, cidade.
 */
export type ThemeId = 'coracaoDaMorena' | 'brasil' | 'roleDaGalera' | 'brasilXMundo';

export interface Theme {
  id: ThemeId;
  name: string;
  currency: string;
  squares: readonly string[];
}

/** Nome da casa de carta: "Legaaaal" são as boas, "F total" as ruins. */
export const CHANCE_NAME = 'F total ou Legaaaal';
const C = CHANCE_NAME;

export const THEMES: Record<ThemeId, Theme> = {
  coracaoDaMorena: {
    id: 'coracaoDaMorena',
    name: 'Coração da Morena',
    currency: 'contos',
    // Nomes curtos para caber numa linha só na casa do tabuleiro (pedido de 20/10).
    squares: [
      'Início',
      'Fiado', 'Perrengue', C, 'Sem Wi-Fi', 'Jegue Turbo', 'Boleto', 'Já Volto',
      'Ilha do Vácuo',
      'Crush', 'Rua do Ex', C, 'Rolê Furado', 'Bike Doida', 'Desculpa', 'Parcelado',
      'Copa Paredão',
      'Fofoca', 'Mercadinho', C, 'Dorme Cedo', 'Barquinho', 'Ostentação', 'Tô Rico',
      'Disco Voador',
      'Coach', 'Influencer', 'Faz o L', 'Mozão', 'Wi-Fi Grátis', 'Sertanejo', 'Morena',
    ],
  },
  brasil: {
    id: 'brasil',
    name: 'Brasil de Ponta a Ponta',
    currency: '$',
    squares: [
      'Início',
      'Juazeiro do Norte', 'Parintins', C, 'Petrolina', 'Lençóis Maranhenses', 'Campina Grande', 'Caruaru',
      'Ilha Grande',
      'Ouro Preto', 'Paraty', C, 'Belém', 'Chapada Diamantina', 'São Luís', 'Manaus',
      'Copa do Brasil',
      'Fortaleza', 'Recife', C, 'Salvador', 'Bonito', 'Porto Alegre', 'Curitiba',
      'Volta ao Brasil',
      'Belo Horizonte', 'Brasília', 'Imposto de Renda', 'Florianópolis', 'Fernando de Noronha', 'Rio de Janeiro', 'São Paulo',
    ],
  },
  roleDaGalera: {
    id: 'roleDaGalera',
    name: 'Rolê da Galera',
    currency: 'pila',
    squares: [
      'Início',
      'Casa da Vó', 'Barraca do Pastel', C, 'Padaria da Esquina', 'Pesqueiro', 'Bar do Zé', 'Campinho de Terra',
      'Castigo',
      'Casa do Primo Folgado', 'Lan House', C, 'Sorveteria', 'Clube do Bairro', 'Pracinha', 'Academia do Bairro',
      'Campeonato do Bairro',
      'Mercadinho', 'Quermesse', C, 'Churrasco da Laje', 'Cachoeira', 'Barbearia', 'Posto de Gasolina',
      'Carona do Tio',
      'Casa do Amigo Rico', 'Festa de Formatura', 'Vaquinha Obrigatória', 'Chácara do Churrasco', 'Casa de Praia do Tio', 'Mansão do Crush', 'Cobertura do Patrão',
    ],
  },
  brasilXMundo: {
    id: 'brasilXMundo',
    name: 'Brasil x Mundo',
    currency: '$',
    squares: [
      'Início',
      'Ouro Preto', 'Olinda', C, 'Jericoacoara', 'Fernando de Noronha', 'Salvador', 'Rio de Janeiro',
      'Ilha Deserta',
      'Buenos Aires', 'Cidade do México', C, 'Lisboa', 'Maldivas', 'Barcelona', 'Roma',
      'Copa do Mundo',
      'Paris', 'Londres', C, 'Sydney', 'Bora Bora', 'Tóquio', 'Los Angeles',
      'Volta ao Mundo',
      'Singapura', 'Mônaco', 'Imposto de Luxo', 'Dubai', 'Ibiza', 'Nova York', 'Xangai',
    ],
  },
};
